import {
  __ErrorManager,
  __EventDispatcher,
  __Lang,
  __UrlParams,
} from "../../core";
import { RGSActions } from "../../config/config.Connections";
import { store } from "../../core.Store";
import { MENU_POPUPS } from "../../../_game/config/Game";
import { EventClass, EventType } from "../../../_game/config/Events";
import { ErrorSeverity } from "../../core.ErrorManager";

export function getEndPoint() {
  if (__UrlParams.props.endpoint) {
    return "wss://" + __UrlParams.props.endpoint + "/marlipin/websocket";
  } else {
    console.error(
      'WSS:getEndPoint failed! You have to specify the "endpoint" parameter in the URL!'
    );
    return "";
  }
}

export function getLoginCommand(bDoReconnect: boolean) {
  let retCommand = {
    type: RGSActions.LOGIN,
    data: {
      requestType: "login",
      //MARLIPIN: use token as sessionID then use received SessionID for all other requests
      sessionID: __UrlParams.props.playToken,
      siteID: __UrlParams.props.siteID,
      brandID: __UrlParams.props.brandID,
      fixedID: __UrlParams.props.fixedID,
      funReal: __UrlParams.props.isFun,
      gameID: __UrlParams.props.gameID,
      reconnect: false,
    },
  };

  // we are reconnecting a dead connection
  if (bDoReconnect) {
    retCommand.data.reconnect = true;
  }

  return retCommand;
}

export function getInitCommnand(sessionID: any) {
  const _cState = store.getState();
  let retCommand = {
    type: RGSActions.INIT,
    data: {
      requestType: "game",
      sessionID: _cState.game.SESSION_DATA.sessionID,
      stakes: [],
      choicesMade: [],
      selections: ["timer"],
      setup: true,
      coins: [],
      // bonusRef1: sendedBonusRef1,
    },
  };

  return retCommand;
}

export function getBalanceCommand() {
  const _cState = store.getState();
  const _sessionID = _cState.game.SESSION_DATA.sessionID;

  let commpayload = {
    requestType: "balance",
    setup: true,
    publicState: { action: "" },
    sessionID: _sessionID,
    bonusRef1: _cState.game.SESSION_DATA.freeBets.bonusRef1,
    gameID: __UrlParams.props.gameID,
  };
  return {
    type: RGSActions.BALANCE,
    data: commpayload,
  };
}

export function getHearthbeatCommand() {
  const _cState = store.getState();
  const _sessID = _cState.game.SESSION_DATA.sessionID;
  let pHBpayload = {
    devEncrypt: false,
    funReal: __UrlParams.props.isFun,
    gameID: __UrlParams.props.gameID,
    requestType: "heartbeat",
    sessionID: _sessID,
    //creditRef: "$mybonusid"
  };
  return pHBpayload;
}

export function getPlaceBetCommand(_numbers: number[]) {
  const _cState = store.getState();
  const _sessID = _cState.game.SESSION_DATA.sessionID;
  const _bet = _cState.game.STATUS_DATA.bet;

  let commpayload = {
    type: RGSActions.PLAY,
    data: {
      requestType: "game",
      sessionID: _sessID,
      selections: ["bet", 1],
      choicesMade: _numbers,
      stakes: [_bet],
      coins: [1],
      setup: false,
      echoRef: false,
      currency: _cState.game.SESSION_DATA.currency.code,
      nextDrawNumber: _cState.game.GAME_DATA.nextDrawNumber,
      nextTimestamp: _cState.game.GAME_DATA.nextTimestamp,
    },
  };

  return commpayload;
}

export function getBetsCommand() {
  const _cState = store.getState();
  const _sessID = _cState.game.SESSION_DATA.sessionID;

  let commpayload = {
    type: RGSActions.BETS,
    data: {
      requestType: "game",
      sessionID: _sessID,
      stakes: [],
      choicesMade: [],
      selections: ["bets"],
      setup: true,
      coins: [],
    },
  };

  return commpayload;
}
export function getSubscriptionCommand(
  _numbers: any[],
  _subscriptions: number
) {
  const _cState = store.getState();
  const _sessID = _cState.game.SESSION_DATA.sessionID;
  const _stake = _cState.game.STATUS_DATA.bet;

  let commpayload = {
    type: RGSActions.SUBSCRIPTION,
    data: {
      requestType: "game",
      sessionID: _sessID,
      stakes: [_stake],
      choicesMade: _numbers,
      selections: ["subscription", _subscriptions],
      setup: false,
      echoRef: false,
      coins: [1],
      nextDrawNumber: _cState.game.GAME_DATA.nextDrawNumber,
      nextTimestamp: _cState.game.GAME_DATA.nextTimestamp,
    },
  };

  return commpayload;
}

export function getLastResultsCommand() {
  const _cState = store.getState();
  const _sessID = _cState.game.SESSION_DATA.sessionID;

  let commpayload = {
    type: RGSActions.LAST_DRAW_RESULTS,
    data: {
      requestType: "game",
      sessionID: _sessID,
      stakes: [],
      choicesMade: [],
      selections: ["getLastDrawResults"],
      setup: true,
      coins: [],
    },
  };

  return commpayload;
}

// does actions based on error codes
// receives object created by getPayloadError()
// returns: false if it already showed an error message or true if the default message must be used
export function handlePayloadError(_errorData: any) {
  // console.log('_errData', _errorData);
  switch (_errorData.errCode) {
    case 19: //BALANCE_TOO_LOW_ERROR_CODE
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
        type: MENU_POPUPS.INSUFFICIENT_FUNDS_WINDOW,
        title: __Lang.translate("n:TEXT_APOLOGIES"),
        content: _errorData.errMessage,
      });
      return false;
    case 115: //BALANCE_TOO_LOW_ERROR_CODE
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
        type: MENU_POPUPS.INSUFFICIENT_FUNDS_WINDOW,
      });
      return false;
    case 117: //RESPONSIBLE_GAMING_BLOCK_ERROR_CODE
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
        type: MENU_POPUPS.RESPONSIBLE_GAMING_BLOCK,
        strTitle: __Lang.translate("n:TEXT_GAME_UNAV_ERROR_TITLE"),
        strText: __Lang.translate("n:TEXT_RESPONSIBLE_BET_ERROR_TEXT"),
      });
      return false;
    case 113: //COULD_NOT_PLACE_BET_ERROR_CODE
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
        type: MENU_POPUPS.RESPONSIBLE_GAMING_EXCEEDED,
        strTitle: __Lang.translate("n:TEXT_APOLOGIES"),
        strText: __Lang.translate("n:TEXT_GENERIC_ERROR_TEXT"),
      });

      return false;
    case 81: //BALANCE_TOO_LOW_ERROR_CODE
      __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
        type: MENU_POPUPS.POPUP_INSURANCE,
        strText: __Lang.translate("n:TEXT_BET_FAILURE_GENERIC"),
        strTitle: __Lang.translate("n:TEXT_GENERIC_ERROR_TITLE"),
      });
      return false;

    default:
      // __ErrorManager.pushError(ErrorSeverity.CRITICAL, _errorData.errCode, _errorData.errCode, "");
      // __EventDispatcher.dispatch(EventClass.GUI, EventType.GUI.SHOW_POPUP, {
      // 	type: MENU_POPUPS.POPUP_RELOAD,
      // 	strTitle: __Lang.translate("n:TEXT_GENERIC_ERROR_TITLE"),
      // 	strText: __Lang.translate("n:TEXT_GENERIC_ERROR_TEXT") + '\n\nError Code: ' + _errorData.errCode,
      // });
      return false;
  }
}

//MARLIPIN:
//115 insufficient credit
//116 invalid session
//117 player blocked
export function getPayloadError(_payload: any) {
  let reterr = {
    errCode: 0,
    errMessage: "",
  };
  if (_payload && _payload.DATA && _payload.DATA.error) {
    if (_payload.DATA.error.errorCode !== 0) {
      const code = _payload.DATA.error.errorCode;
      // save real code
      reterr.errCode = code;
      reterr.errMessage = _payload.DATA.error.errorMessage;

      switch (code) {
        case 115: //BALANCE_TOO_LOW_ERROR_CODE
          reterr.errMessage = __Lang.translate("n:TEXT_ZERO_FOUNDS_LABEL");
          break;
        case 116: //Invalid Session
          reterr.errMessage = __Lang.translate("n:TEXT_INVALID_SESSION");
          break;
        case 117: //RESPONSIBLE_GAMING_BLOCK_ERROR_CODE
          reterr.errMessage = __Lang.translate(
            "n:TEXT_RESPONSIBLE_BET_ERROR_TEXT"
          );
          break;
        case 113: //COULD_NOT_PLACE_BET_ERROR_CODE
          reterr.errMessage = __Lang.translate("n:TEXT_BET_EXCEED_ERROR_TEXT");
          break;
        case 19:
          if (
            _payload.DATA.error.errorMessage.search(
              /CURRENCY NOT SUPPORTED/
            ) !== -1
          ) {
            reterr.errMessage = __Lang.translate("n:TEXT_UNSUPORTED_CURRENCY");
          } else {
            reterr.errMessage = __Lang.translate("n:TEXT_GENERIC_ERROR_TEXT");
          }
          break;
        default:
          reterr.errMessage = __Lang.translate("n:TEXT_GENERIC_ERROR_TEXT");
          break;
      }
      /** @proxy - PROVIDER PROXY - if you change your mind */
      // __ProxiProvider.notifyError({ errCode: reterr.errCode });
    }
  }

  //console.log('!- getPayloadError:', reterr);
  return reterr;
}

export function handleServerMessage(_payload: any) {
  console.log("Unexpected message received:", _payload);
}

export function getFailedBetsCommand() {
  const _cState = store.getState();
  const _sessID = _cState.game.SESSION_DATA.sessionID;

  const command = {
    type: RGSActions.FAILED_BETS,
    data: {
      requestType: "game",
      sessionID: _sessID,
      stakes: [],
      choicesMade: [],
      selections: ["failedCancelled"],
      setup: true,
      coins: [],
    },
  };
  return command;
}
